import styled from '@emotion/styled';
import { Button, MetaWhite, Text } from '@innovationdepartment/proxima-ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  gap: 8px;
  align-self: stretch;
  background: linear-gradient(90deg, rgba(201, 250, 236, 0.9), rgba(203, 219, 254, 0.9));
  backdrop-filter: blur(5px);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 69px;
  z-index: 4;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  width: 630px;
  text-align: center;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const SmallerMetaIcon = styled(MetaWhite)`
  width: 16px;
  height: 16px;
`;

type InsightsNoMetaIntegrationProps = {
  onConnectMetaAccountClicked: () => void;
};

const InsightsNoMetaIntegration = (props: InsightsNoMetaIntegrationProps) => {
  const { onConnectMetaAccountClicked } = props;

  return (
    <Container>
      <ContentContainer>
        <InnerContainer>
          <Text variant="h2">Want see how your brand stacks up?</Text>
          <Text variant="h6" isTermina={false}>
            {`Connect your ad account to see how your brand's performance compares to specific
            cohorts or the entire eCommerce industry.`}
          </Text>
        </InnerContainer>
        <InnerContainer>
          <Button
            onClick={onConnectMetaAccountClicked}
            size="medium"
            startIcon={<SmallerMetaIcon />}
            label={<Text variant="body2Semibold">Connect Meta</Text>}
          />
        </InnerContainer>
      </ContentContainer>
    </Container>
  );
};

export default InsightsNoMetaIntegration;
